import React, {useState, useEffect } from 'react';
import { Modal, Tabs, Tab } from 'react-bootstrap';
import {useSelector, useDispatch } from 'react-redux';
import Footer from './footer';
import Header from './header';
import { Link, withRouter, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import Loader from 'react-loader-spinner';
import { CreateDioceseOfficial, CreateProfile, EditProfile, GetDioceseOfficial } from '../redux/action';
import { IMAGEPATH } from '../redux/action/constant';
import AsyncSelect from 'react-select/async';
import { GetParish } from '../Message/getdata';


const EditPriestInformation = (props) => {

    const [ show, setshow ] = useState(false);
    const [ edit, setedit ] = useState(false);
    const { handleSubmit, errors, register, watch } = useForm();
	const dispatch = useDispatch();
    const [IsSubmitting, setIsSubmitting ] = useState(false);
    const { id } = useParams();
    const [ file, setfile ] = useState(null);
    const dioceanofficials = useSelector(state=>state.root.dioceanofficials);
    const [ IsMarried, setIsMarried ] = useState(false);
    const [ parish, setparish ] = useState(null);

    const onSubmit = async (data,e) => {
        
        if(IsMarried == "Married" && (data.name_of_spouse == '' || data.qualification_of_spouse == ''))
        {
            alert('Spouse Information is Required');
            return false;
        }

        if(data.date_married == '')
        {
            alert('Date Married is Required');
            return false;
        }
        setIsSubmitting(true);
        //alert(JSON.stringify(data.date_commissioned));
        //console.log(data);
        const formdata = new FormData();
        formdata.append('firstname',data.firstname);
        formdata.append('lastname',data.lastname);
        formdata.append('middlename', data.middlename);
        formdata.append('email1',data.email1);
        formdata.append('email2', data.email2);
        formdata.append('phonenumber1', data.phonenumber1);
        formdata.append('phonenumber2', data.phonenumber2);
        formdata.append('date_priested', data.date_priested);
        formdata.append('date_deaconed', data.date_deaconed);
        formdata.append('position', data.position);
        formdata.append('status', data.status);
        formdata.append('gender', data.gender);
        formdata.append('date_of_birth', data.date_of_birth);
        formdata.append('date_commissioned', data.date_commissioned);
        formdata.append('marital_status', data.marital_status);
        formdata.append('name_of_spouse', data.name_of_spouse == undefined ? '' : data.name_of_spouse);
        formdata.append('qualification_of_spouse', data.qualification_of_spouse == undefined ? '' : data.qualification_of_spouse);
        formdata.append('date_married', data.date_married == undefined ? '' : data.date_married);
        formdata.append('parishId', parish == null ? props.priest.parish_id : parish);
        formdata.append('profile_status', data.profile_status);
        //formdata.append('archdeaconry_id', data.archdeaconry_id);
        if(file != null) formdata.append('image', file != null ? file : '');
        let dioceseId = window.atob(id);
        await dispatch(EditProfile(formdata, props.priest.id));
        setIsSubmitting(false);
    }

    const handleFile = (event) => {
        setfile(event.target.files[0]);
    }

    const loadOptions = async (inputValue, callback) => {
        let r = await GetParish(inputValue);
        return r;
     }


    const handleStatus = (event) => {
        setIsMarried(event.target.value);
    }

    useEffect(() => {
        if(props.priest.marital_status == 'Married')
        {
            setIsMarried('Married');
        }
    },[])

    return (
        <div className="">
         
        
        <div style={{marginTop:30}}>
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row" style={{marginBottom:-20}}>
                <div className="col-lg-6 col-sm-6">  
                <small className="text-secondary" style={{fontSize:14}}>First name</small>  
                <input 
                    className="form-control"
                    defaultValue = {props.priest.firstname}
                    name ="firstname"
                    type ="text" 
                    ref={register({
                        required: "Required"
                        })}
                />
                    <small className="text-danger" style={{fontSize:13}}>{errors.firstname?.type == "required" && "First Name is required"}</small>
                </div>
                <div className="col-lg-6 col-sm-6">
                <small className="text-secondary" style={{fontSize:14}}>Last name</small>     
                <input 
                    className="form-control" 
                    defaultValue = {props.priest.lastname}
                    name ="lastname"
                    type ="text" 
                    ref={register({
                        required: "Required"
                        })}
                />
                    <small className="text-danger" style={{fontSize:13}}>{errors.lastname?.type == "required" && "Last Name is required"}</small>
                </div>
            </div>
            <div className="row" style={{marginBottom:-20,paddingBottom:0}}>
                <div className="col-lg-6 col-sm-6">
                <small className="text-secondary" style={{fontSize:14}}>Middlename</small>     
                <input 
                    className="form-control" 
                    defaultValue = {props.priest.middlename}
                    name ="middlename"
                    type ="text" 
                    ref={register({
                       
                        })}
                />
                    <small className="text-danger" style={{fontSize:13}}>{errors.middlename?.type == "required" && "Middle Name is required"}</small>
                </div>
                <div className="col-lg-6 col-sm-6">
                <small className="text-secondary" style={{fontSize:14}}>Phone Number 1</small>     
                <input 
                    className="form-control" 
                    defaultValue = {props.priest.phonenumber1}
                    name ="phonenumber1"
                    type ="number" 
                    ref={register({
                        required: "Required"
                        })}
                />
                    <small className="text-danger" style={{fontSize:13}}>{errors.phonenumber1?.type == "required" && "Phone Number 1 is required"}</small>
                </div>
            </div>
            <div className="row"    style={{marginBottom:-20}}>
                <div className="col-lg-6 col-sm-6">
                <small className="text-secondary" style={{fontSize:14}}>Phone Number 2</small>     
                <input 
                    className="form-control" 
                    defaultValue = {props.priest.phonenumber2}
                    name ="phonenumber2"
                    type ="number" 
                    ref={register({
                        
                        })}
                />
                    <small className="text-danger" style={{fontSize:13}}>{errors.phonenumber2?.type == "required" && "Phone NUmber 2 is required"}</small>
                </div>
                <div className="col-lg-6 col-sm-6">
                <small className="text-secondary" style={{fontSize:14}}>Email 1</small>     
                <input 
                    className="form-control" 
                    defaultValue = {props.priest.email1}
                    name ="email1"
                    type ="email" 
                    ref={register({
                        required: "Required"
                        })}
                />
                    <small className="text-danger" style={{fontSize:13}}>{errors.email1?.type == "required" && "Email is required"}</small>
                </div>
            </div>

            <div className="row"    style={{marginBottom:-20}}>
                <div className="col-lg-6 col-sm-6">
                <small className="text-secondary" style={{fontSize:14}}>Email 2</small>     
                <input 
                    className="form-control" 
                    defaultValue = {props.priest.email2}
                    name ="email2"
                    type ="email" 
                    ref={register({
                    
                        })}
                />
                    <small className="text-danger" style={{fontSize:13}}>{errors.email2?.type == "required" && "Email 2 is required"}</small>
                </div>
                <div className="col-lg-6 col-sm-6">
                <small className="text-secondary" style={{fontSize:14}}>Status</small>     
                <select name ="status"
                        name = "status"
                        defaultValue = {props.priest.status}                        
                        className="form-control" 
                        ref={register({
                        required: "Required"
                        })}
                >
                    <option value="">Status</option>
                    <option value="Most Revd">Most Revd</option>
                    <option value="Right Revd">Right Revd</option>
                    <option value="Very Revd">Very Revd</option>
                    <option value="Venerable">Venerable</option>
                    <option value="Revd Canon">Revd Canon</option>
                    <option value="Revd">Revd</option>
                    <option value="Evangelist">Evangelist</option>
                    <option value="Mr.">Mr.</option>
                </select>
                    <small className="text-danger" style={{fontSize:13}}>{errors.status?.type == "required" && "Status is required"}</small>
                </div>
            </div>

            <div className="row"    style={{marginBottom:-20}}>
                
                <div className="col-lg-6 col-sm-6">
                <small className="text-secondary" style={{fontSize:14}}>Date Of Birth</small>     
                <input 
                    className="form-control" 
                    defaultValue = {props.priest.date_of_birth}
                    name ="date_of_birth"
                    type ="date" 
                    ref={register({
                        required: "Required"
                        })}
                />
                    <small className="text-danger">{errors.file?.type == "required" && "Image is required"}</small>
                </div>
                <div className="col-lg-6 col-sm-6">
                <small className="text-secondary" style={{fontSize:14}}>Date Deaconed</small>     
                <input 
                    className="form-control" 
                    defaultValue = {props.priest.date_deaconed}
                    name ="date_deaconed"
                    type ="date" 
                    ref={register({
                        required: "Required"
                        })}
                />
                    <small className="text-danger" style={{fontSize:13}}>{errors.file?.type == "required" && "Image is required"}</small>
                </div>
            </div>
            <div className="row"    style={{marginBottom:-20}}>
                <div className="col-lg-6 col-sm-6">
                <small className="text-secondary" style={{fontSize:14}}>Date Priested</small>    
                <input 
                    className="form-control"                            
                    name ="date_priested"
                    defaultValue = {props.priest.date_priested}
                    type ="date" 
                    ref={register({
                    
                        })}
                />
                    <small className="text-danger" style={{fontSize:13}}>{errors.file?.type == "required" && "Image is required"}</small>
                </div>
                <div className="col-lg-6 col-sm-6">
                <small className="text-secondary" style={{fontSize:14}}>Gender</small>     
                <select 
                className="form-control" 
                defaultValue = {props.priest.gender}
                name ="gender"
                ref={register({
                    })}
                >
                    <option value=""></option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                </select>    
                <small className="text-danger" style={{fontSize:13}}>{errors.marital_status?.type == "required" && "Marital Status is required"}</small>
                </div>
            
                
            
            </div>
            <div className="row"    style={{marginBottom:10}}>
                <div className="col-lg-12 col-sm-12">
                <small className="text-secondary" style={{fontSize:14}}>Date Commissioned</small>    
                <input 
                    className="form-control"                            
                    name ="date_commissioned"
                    defaultValue = { props.priest.date_commissioned != null && props.priest.date_commissioned}
                    type ="date" 
                    ref={register({
                    
                        })}
                />
                </div>
            </div>
            <div className="row"    style={{marginBottom:-20}}>
                <div className="col-lg-6 col-sm-6">
                <small className="text-secondary" style={{fontSize:14}}>Position</small>     
                <select
                        name ="position"
                        className="form-control" 
                        defaultValue = {props.priest.position}
                        ref={register({
                        required: "Required"
                        })}
                >
                    <option value="">Position</option>
                    <option value="Primate">Primate</option>
                    <option value="Archbishop">Archbishop</option>
                    <option value="Bishop">Bishop</option>
                    <option value="Provost">Provost</option>
                    <option value="Dean">Dean</option>
                    <option value="Vicar">Vicar</option>
                    <option value="Curate">Curate</option>
                    <option value="Deacon">Deacon</option>
                    <option value="Evangelist">Evangelist</option>
                    <option value="Catechist">Catechist</option>
                    <option value="Agent">Agent</option>
                </select>
                    <small className="text-danger" style={{fontSize:13}}>{errors.position?.type == "required" && "Position is required"}</small>
                </div>
                
                <div className="col-lg-6 col-sm-6">
                <small className="text-secondary" style={{fontSize:14}}>Marital Status</small>     
                <select 
                className="form-control" 
                defaultValue = {props.priest.marital_status}
                name ="marital_status"
                onChange = {handleStatus}
                ref={register({
                    required: "Required"
                    })}
                >
                    <option value=""></option>
                    <option value="Single">Single</option>
                    <option value="Married">Married</option>
                </select>    
                <small className="text-danger" style={{fontSize:13}}>{errors.marital_status?.type == "required" && "Marital Status is required"}</small>
                </div>
                
            </div>
           
            {
                IsMarried == "Married" &&
            <div className="row"    style={{marginBottom:-20}}>
                <div className="col-lg-6 col-sm-6">
                <small className="text-secondary" style={{fontSize:14}}>Name Of Spouse</small>    
                <input 
                    className="form-control"                            
                    name ="name_of_spouse"
                    defaultValue = {props.priest.name_of_spouse}
                    type ="text" 
                    ref={register({
                    
                        })}
                />
                </div>
                <div className="col-lg-6 col-sm-6">
                <small className="text-secondary" style={{fontSize:14}}>Qualification Of Spouse</small>     
                <input 
                    className="form-control"                            
                    name ="qualification_of_spouse"
                    defaultValue = {props.priest.qualification_of_spouse}
                    type ="text" 
                    ref={register({
                    
                        })}
                />   
                </div>
            
            </div>
            }
            {
                IsMarried == "Married" &&
                <div className="row"  style={{marginBottom:-20}}>
                    <div className="col-lg-6 col-sm-6">
                    <small className="text-secondary" style={{fontSize:14}}>Date Married</small>    
                    <input 
                        className="form-control"                            
                        name ="date_married"
                        defaultValue = {props.priest.date_married}
                        type ="date" 
                        ref={register({
                        
                            })}
                    />
                    </div>
                </div>  
            }  
            <div className="row"  style={{marginBottom:10}}>    
                <div className="col-lg-6 col-sm-6">
                <small className="text-secondary" style={{fontSize:14}}>Priest Image</small>     
                <input 
                    className="form-control" 
                    placeholder ="Image" 
                    onChange = { handleFile }
                    type ="file" 
                    ref={register({
                    
                        })}
                />   
                <small className="text-danger" style={{fontSize:13}}>{errors.file?.type == "required" && "Image is required"}</small>
                </div>
                <div className="col-lg-6 col-sm-6" style={{fontSize:14,marginTop:20}}>
                <small className="text-secondary" style={{fontSize:14}}>Parish Name (search for Parish)</small>     
                 <AsyncSelect   
                        cacheOptions
                        style ={{fontSize:12}}
                        placeholder="Choose Parish"
                        loadOptions = {loadOptions}
                        isClearable
                        onChange = {(opt) => setparish(opt==null ? '' : opt.value) }
                    />  
                </div>
            
            </div>
            <div className="row"  style={{marginBottom:10}}>    
                <div className="col-lg-12 col-sm-12">
                <small className="text-secondary" style={{fontSize:14}}>Profile Status</small>     
                <select
                     className="form-control" 
                     name="profile_status"
                     placeholder ="Profile Status (Sacked, Dead, Inter Diocesan Transfer, Retired)" 
                     ref={register({
                     
                         })}
                >
                    <option value=""></option>
                    <option value="Sacked">Sacked</option>
                    <option value="Dead">Dead</option>
                    <option value="Retired">Retired</option>
                    <option value="Inter Diocesan Transfer">Inter Diocesan Transfer</option>
                </select>   
                </div>
               
            
            </div>
            <div className="row" style={{marginTop:10}}>
                <div className="col-lg-4 col-sm-4">
                <div style={{marginTop:0}} class="">
                {
                IsSubmitting == false &&
                <button type ="submit" class="mdc-button mdc-button--raised">
                    Submit
                </button>
                }
                {
                IsSubmitting == true &&
                <div style={{textAlign:'center'}}>
                <Loader
                    visible={true}
                    type="Puff"
                    color="#7a00ff"
                    height={30}
                    width={30}
                    timeout= {0} //3 secs
                />
                </div>
                }
            </div>
                </div>
                
            </div>
        </form>           
        </div>
     </div>
    );
}

export default EditPriestInformation;